<template>
  <div>
    <MainTopNavBar />

    <section
      id="invite"
      class="pad-lg light-gray-bg"
    >
      <div class="container">
        <div class="row">
          <div class="col-sm-8 col-sm-offset-2 text-center">
            <slot name="content">
              default header
            </slot>
            <br>

            <!--<Contact />-->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import MainTopNavBar from "@/components/MainTopNavBar.vue";
import Contact from "@/components/Contact.vue";
export default {
  components: {
    MainTopNavBar
  }
};
</script>